import { useEffect, useState } from "react";
import { Form, Input, Select, Button, message, Card, Divider } from "antd";
import axios from "axios";
import { API_BASE } from "../../config/api";
import { getAuthHeaders } from "../../utils/auth";

const { Option } = Select;

const API = API_BASE;

const CreateEmployee = ({fetchData}) => {
  const [form] = Form.useForm();

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [services, setServices] = useState([]);

  const [employeeId, setEmployeeId] = useState(null);
  const [loading, setLoading] = useState(false);

  // ===============================
  // Obtener categorías
  // ===============================
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API}/category`);
        setCategories(res.data);
      } catch (error) {
        message.error("Error cargando categorías");
      }
    };

    fetchCategories();
  }, []);

  // ===============================
  // Cambio de categoría
  // ===============================
  const handleCategoryChange = (categoryId) => {
    const category = categories.find((c) => c.id === categoryId);

    setSubCategories(category?.SubCategories || []);
    setServices([]);

    form.setFieldsValue({
      subCategory: null,
      services: [],
    });
  };

  // ===============================
  // Cambio de subcategoría
  // ===============================
  const handleSubCategoryChange = (subCategoryId) => {
    const subCategory = subCategories.find((sc) => sc.id === subCategoryId);

    setServices(subCategory?.Services || []);

    form.setFieldsValue({
      services: [],
    });
  };

  // ===============================
  // Submit
  // ===============================
  const onFinish = async (values) => {
    setLoading(true);

    try {
      let id = employeeId;

      // 1️⃣ Crear empleado solo una vez
      if (!id) {
        const res = await axios.post(`${API}/employees`, {
          name: values.name,
          email: values.email,
        }, {
          headers: getAuthHeaders(),
        });

        id = res.data.id;
        setEmployeeId(id);

        message.success("Empleado creado");
      }

      // 2️⃣ Asignar servicios al mismo empleado
      await axios.post(`${API}/employees/${id}/services`, {
        serviceIds: values.services,
      }, {
        headers: getAuthHeaders(),
      });

      message.success("Servicios agregados al empleado");

      // Reset solo selects
      form.setFieldsValue({
        category: null,
        subCategory: null,
        services: [],
      });

      setSubCategories([]);
      setServices([]);
      fetchData()
    } catch (error) {
      message.error("Error guardando empleado");
    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // Reset completo (nuevo empleado)
  // ===============================
  const resetEmployee = () => {
    setEmployeeId(null);
    setSubCategories([]);
    setServices([]);
    form.resetFields();
  };

  // ===============================
  // UI
  // ===============================
  return (
    <Card  style={{ maxWidth: 500, justifyContent: "center", margin: "0 auto" }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>

        {/* Nombre */}
        <Form.Item
          label="Nombre del empleado"
          name="name"
          rules={
            employeeId
              ? []
              : [{ required: true, message: "El nombre es obligatorio" }]
          }
        >
          <Input
            placeholder="Ej: Juan Pérez"
            disabled={!!employeeId}
          />
        </Form.Item>

        <Form.Item
          label="Email del empleado"
          name="email"
          rules={
            employeeId
              ? []
              : [
                  { required: true, message: "El email es obligatorio" },
                  { type: "email", message: "Ingresá un email válido" },
                ]
          }
        >
          <Input
            placeholder="Ej: juan@estudioisaac.com"
            disabled={!!employeeId}
          />
        </Form.Item>

        {employeeId && (
          <Divider style={{ margin: "10px 0" }}>
            Agregar servicios
          </Divider>
        )}

        {/* Categoría */}
        <Form.Item
          label="Categoría"
          name="category"
          rules={[{ required: true, message: "Seleccioná una categoría" }]}
        >
          <Select
            placeholder="Seleccionar categoría"
            onChange={handleCategoryChange}
          >
            {categories.map((cat) => (
              <Option key={cat.id} value={cat.id}>
                {cat.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Subcategoría */}
        <Form.Item
          label="Subcategoría"
          name="subCategory"
          rules={[{ required: true, message: "Seleccioná una subcategoría" }]}
        >
          <Select
            placeholder="Seleccionar subcategoría"
            onChange={handleSubCategoryChange}
            disabled={!subCategories.length}
          >
            {subCategories.map((sc) => (
              <Option key={sc.id} value={sc.id}>
                {sc.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Servicios */}
        <Form.Item
          label="Servicios que realiza"
          name="services"
          rules={[
            { required: true, message: "Seleccioná al menos un servicio" },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Seleccionar servicios"
            disabled={!services.length}
          >
            {services.map((service) => (
              <Option key={service.id} value={service.id}>
                {service.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Botones */}
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
          >
            {employeeId ? "Agregar servicios" : "Crear empleado"}
          </Button>
        </Form.Item>

        {employeeId && (
          <Button danger block onClick={resetEmployee}>
            Crear otro empleado
          </Button>
        )}

      </Form>
    </Card>
  );
};

export default CreateEmployee;
